export const FETCH_DRAFT_JOB = "FETCH_DRAFT_JOB";

export const DELETE_DRAFT_JOB = "DELETE_DRAFT_JOB";
export const DELETE_DRAFT_JOB_SUCCESS = "DELETE_DRAFT_JOB_SUCCESS";
export const DELETE_DRAFT_JOB_FAILURE = "DELETE_DRAFT_JOB_FAILURE";

export const FETCH_JOB_FORM = "FETCH_JOB_FORM";
export const FETCH_JOB_FORM_SUCCESS = "FETCH_JOB_FORM_SUCCESS";
export const FETCH_JOB_FORM_FAILURE = "FETCH_JOB_FORM_FAILURE";
export const FETCH_JOB_FORM_RESET = "FETCH_JOB_FORM_RESET";

export const FETCH_JOB_DOCUMENT_FORM = "FETCH_JOB_DOCUMENT_FORM";
export const FETCH_JOB_DOCUMENT_FORM_SUCCESS =
  "FETCH_JOB_DOCUMENT_FORM_SUCCESS";
export const FETCH_JOB_DOCUMENT_FORM_FAILURE =
  "FETCH_JOB_DOCUMENT_FORM_FAILURE";

export const FETCH_JOB_FORM_SUBMISSION = "FETCH_JOB_FORM_SUBMISSION";
export const FETCH_JOB_FORM_SUBMISSION_SUCCESS =
  "FETCH_JOB_FORM_SUBMISSION_SUCCESS";
export const FETCH_JOB_FORM_SUBMISSION_FAILURE =
  "FETCH_JOB_FORM_SUBMISSION_FAILURE";

export const CLEAR_JOB_FORM_SUBMISSION = "CLEAR_JOB_FORM_SUBMISSION";

export const SET_FORM_SUBMISSION = "SET_FORM_SUBMISSION";

export const FETCH_SECOND_JOB_FORM = "FETCH_SECOND_JOB_FORM";
export const FETCH_SECOND_JOB_FORM_SUCCESS = "FETCH_SECOND_JOB_FORM_SUCCESS";
export const FETCH_SECOND_JOB_FORM_FAILURE = "FETCH_SECOND_JOB_FORM_FAILURE";
export const FETCH_SECOND_JOB_FORM_RESET = "FETCH_SECOND_JOB_FORM_RESET";
